var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.34316 2.76002L5.67483 1.09169C2.87483 3.22669 1.0315 6.51669 0.868164 10.25H3.2015C3.3765 7.15835 4.96316 4.45169 7.34316 2.76002ZM21.7982 10.25H24.1315C23.9565 6.51669 22.1132 3.22669 19.3248 1.09169L17.6682 2.76002C20.0248 4.45169 21.6232 7.15835 21.7982 10.25ZM19.4998 10.8334C19.4998 7.25169 17.5865 4.25335 14.2498 3.46002V2.66669C14.2498 1.69835 13.4682 0.916687 12.4998 0.916687C11.5315 0.916687 10.7498 1.69835 10.7498 2.66669V3.46002C7.4015 4.25335 5.49983 7.24002 5.49983 10.8334V16.6667L3.1665 19V20.1667H21.8332V19L19.4998 16.6667V10.8334ZM12.4998 23.6667C12.6632 23.6667 12.8148 23.655 12.9665 23.62C13.7248 23.4567 14.3432 22.9434 14.6465 22.2434C14.7632 21.9634 14.8215 21.66 14.8215 21.3334H10.1548C10.1665 22.6167 11.2048 23.6667 12.4998 23.6667Z",
    fill: "#2DB875"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertGreenIcon);
export default __webpack_public_path__ + "static/media/alert-green_icon.10e18ef5a0901c69b632dcd79858f6b1.svg";
export { ForwardRef as ReactComponent };